import { render, staticRenderFns } from "./BetMatchList.vue?vue&type=template&id=5a694ec2&scoped=true"
import script from "./BetMatchList.vue?vue&type=script&lang=js"
export * from "./BetMatchList.vue?vue&type=script&lang=js"
import style0 from "./BetMatchList.vue?vue&type=style&index=0&id=5a694ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a694ec2",
  null
  
)

export default component.exports